import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { CurrencyInput } from '@americanexpress/dls-react';

/**
 * returns DLS currency component
 * @param {*} props
 */
const RequestLimit = ({
  cssProperties,
  fieldName,
  fieldId,
  fieldOptions,
  fieldLabel,
  fieldLabel1,
  fieldLabel2,
  setCurrencySymbol,
  fieldValidation,
}) => {
  const [value, setValue] = useState('');
  const [requestedLimit, setRequestedLimit] = useState('');
  const inputRef = useRef(null);
  let dlsClass;

  // if background color change is required
  if (fieldValidation.bgColor) {
    dlsClass = `${fieldValidation.bgColor}`;
  }

  /**
     * handle input change
     * @param {*} e
     */
  const changeHandler = (e) => {
    if (e.target.value === 'No') {
      // setElementType('number');
      inputRef.current.value = '';
      setRequestedLimit('');
    }
    if (e.target.value === 'Yes') {
      // setElementType('text');
      inputRef.current.value = 'Max';
      setRequestedLimit('Max');
    }
    setValue(e.target.value);
    setCurrencySymbol(fieldLabel.currencyUnit);
  };

  /* eslint-disable unicorn/prefer-number-properties -- desc */
  const patternValidation = (e) => {
    if (fieldValidation.regex) {
      const val = parseInt(e.target.value.replace(/,/g, ''), 10);
      const re = new RegExp(fieldValidation.regex.pattern);
      if (!re.test(val)) {
        e.target.setCustomValidity(fieldValidation.regex.message);
      } else {
        e.target.setCustomValidity('');
      }
    }
  };
  /* eslint-enable unicorn/prefer-number-properties -- desc */

  const handleRequestedLimit = (e) => {
    setRequestedLimit(e.target.value);
    setCurrencySymbol(fieldLabel.currencyUnit);
    patternValidation(e);
  };

  return (
    <div className={cssProperties.style}>
      <p className="label-3">Requested Limit</p>
      <p className="margin-2-b">
        {fieldLabel1}
      </p>
      <span>  </span>
      <div className="row pad-1-l">
        {
          fieldOptions.map((option) => (
            <div className="radio pad-4-r" key={option.fieldId}>
              <input
                id={option.fieldId}
                type="radio"
                name={option.fieldName}
                value={option.value}
                checked={value === option.value}
                onChange={changeHandler}
                required={fieldValidation.required}
              />
              <label htmlFor={option.fieldId} className="">
                {option.fieldLabel}
              </label>
            </div>
          ))
        }
      </div>
      <p>{fieldLabel2} </p>
      <div className="currency-field">

        <CurrencyInput
          id={fieldId}
          label={fieldLabel.label}
          name={fieldName}
          className={dlsClass}
          defaultValue={requestedLimit}
          onBlur={handleRequestedLimit}
          ref={inputRef}
          required={fieldValidation.required}
          currency={fieldValidation.currencyUnit}
          locale={fieldValidation.locale ? fieldValidation.locale : 'en-US'}
          disabled={value === 'Yes' || value === '' ? fieldValidation.disabled : !fieldValidation.disabled}
          showFractions={fieldValidation.showFractions === false
            ? fieldValidation.showFractions : true}
        />
        {
          value === 'Yes' && (
            <input type="hidden" id={fieldName} name={fieldName} value={requestedLimit} />
          )
        }
      </div>
    </div>
  );
};

RequestLimit.propTypes = {
  cssProperties: PropTypes.objectOf(PropTypes.shape),
  fieldLabel: PropTypes.objectOf(PropTypes.shape),
  fieldId: PropTypes.string,
  fieldOptions: PropTypes.objectOf(PropTypes.shape),
  fieldName: PropTypes.string,
  setCurrencySymbol: PropTypes.func,
  fieldValidation: PropTypes.objectOf(PropTypes.shape),
  fieldLabel1: PropTypes.string,
  fieldLabel2: PropTypes.string,
};

export default RequestLimit;
